/** Thrown when a command's input violates a domain invariant (docs/03 §8) before writing. */
export class DomainError extends Error {
    code;
    invariant;
    constructor(code, message, invariant) {
        super(message);
        this.name = 'DomainError';
        this.code = code;
        this.invariant = invariant;
    }
}
export const ACTIONABLE_KINDS = ['item', 'task', 'project'];
export function isActionableKind(kind) {
    return ACTIONABLE_KINDS.includes(kind);
}
//# sourceMappingURL=types.js.map